/**
 * Scores Store - Live game scores from ESPN
 * ==========================================
 * Created: 2025-12-11
 *
 * Stores live scores received via WebSocket (SCORES_INIT, SCORES_UPDATE).
 * Keyed by canonical_id for easy lookup.
 */
import { create } from 'zustand'

export const useScoresStore = create((set, get) => ({
  // Map of canonical_id -> score data
  scores: {},

  // Update a single game's score
  updateScore: (canonicalId, scoreData) =>
    set((state) => ({
      scores: {
        ...state.scores,
        [canonicalId]: {
          ...state.scores[canonicalId],
          ...scoreData,
          lastUpdated: Date.now()
        }
      }
    })),

  // Batch update multiple scores (for SCORES_INIT and bulk SCORES_UPDATE)
  batchUpdateScores: (items) => {
    if (!items || items.length === 0) return

    set((state) => {
      const newScores = { ...state.scores }
      const now = Date.now()

      items.forEach((item) => {
        const key = item.canonical_id
        if (key) {
          newScores[key] = {
            ...newScores[key],
            ...item,
            lastUpdated: now
          }
        }
      })

      return { scores: newScores }
    })
  },

  // Get score for a specific game
  getScore: (canonicalId) => {
    const state = get()
    return state.scores[canonicalId] || null
  },

  // Get all scores for a sport
  getScoresBySport: (sport) => {
    const state = get()
    return Object.values(state.scores).filter(
      (item) => item.sport?.toUpperCase() === sport.toUpperCase()
    )
  },

  // Clear all scores
  clearScores: () => set({ scores: {} }),

  // Get count of live scores
  getLiveCount: () => {
    const state = get()
    return Object.values(state.scores).filter(s => s.is_live).length
  }
}))
